export class DebugPanelHelper {
  static enabled = false;
}
